<template lang="pug">
div
  h3.p-title.p-title--icon {{$t('shared.risk_objects.generic.family')}}
    Icon(icon="family", classes="p-title__icon")
  Ownership(risk="family" risk_object="rc")
  Ownership(risk="family" risk_object="pj")
  Ownership(risk="family" risk_object="hospitalization")
  Ownership(risk="family" risk_object="e_reputation")
  Ownership(risk="family" risk_object="driver")
  Ownership(risk="family" risk_object="heritage" v-if="shouldInsureSuccession")
  Ownership(risk="family" risk_object="funeral" v-if="shouldInsureFunerals")
  Ownership(risk="family" risk_object="pet" v-if="shouldInsurePets")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'

export default {
  components: {
    Icon,
    Ownership
  },
  computed: {
    shouldInsurePets () {
      return JSON.parse(this.$store.state.person.has_pet)
    },
    shouldInsureSuccession () {
      return this.$store.getters.getAge > 65
    },
    shouldInsureFunerals () {
      return this.$store.getters.getAge > 50
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/Family.vue